module.exports = __webpack_public_path__ + "img/3DPrinter.67f2e1e9.png";